var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15.922c0 7.69-6.233 13.922-13.922 13.922a13.86 13.86 0 0 1-8.169-2.647 9.014 9.014 0 0 1-1.293 1.49c-1.52 1.389-3.663 1.24-4.544.992-.055-2.452-.132-8.412 0-12.642.015-.476.044-.92.084-1.334C2.274 8.116 8.462 2 16.077 2 23.768 2 30 8.233 30 15.922zm-6.114.042a8.015 8.015 0 1 1-16.03 0 8.015 8.015 0 0 1 16.03 0zm-3.14-.248a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbg);
export default __webpack_public_path__ + "static/media/CBG.ccf959e0666343de2b0416361c288380.svg";
export { ForwardRef as ReactComponent };